import FJSwipe from '../../../common/components/FJSwipe/FJSwipe';
import styles from './FJUrlToVideoScriptEdit.module.less';
import PropTypes from 'prop-types';
import FJLocalStore from '../../../store/FJLocalStore';
import FJSceneTextListContainer from '../FJSceneTextbox/FJSceneTextListContainer';
import FJButton, { FJButtonType } from '../../../common/components/FJButton/FJButton';
import FJCheckBox from '../../../common/components/FJCheckBox/FJCheckBox';
import { useState, useRef } from 'react';
import FJAddTextIcon from '../../../assets/svg/textToVideo/add-text.svg?react';
import FJCopyIcon from '../../../assets/svg/textToVideo/copy.svg?react';
import FJUtil from '../../../util/FJUtil';
import FJMessageStore from '../../../store/FJMessageStore';
import FJToolTip from '../../../common/components/FJToolTip/FJToolTip';
import classNames from 'classnames';
import FJTextToVideoFooter from '../FJTextToVideoFooter/FJTextToVideoFooter';
const SELECT_COMPONENT_WIDTH = 78;
const FJUrlToVideoScriptEdit = props => {
    const { spiderData, useSpiderImage, setUseSpiderImage, addSceneText, onSpiderEditNext } = props;
    const [selectComponentStyle, setSelectComponentStyle] = useState({ x: 0, y: 0, display: 'none' });
    const selectTextRef = useRef(null);
    const textareaRef = useRef(null);
    const mouseDownRef = useRef(null);
    const spiderDataRef = useRef(null);
    const _calcSelectComponentPosition = (selectedText, { clientX, clientY }) => {
        if (!textareaRef.current || !mouseDownRef.current) {
            return;
        }
        const minY = Math.min(clientY, mouseDownRef.current.clientY);
        let left = 0;
        let top = 0;

        const rect = textareaRef.current.getBoundingClientRect();
        const { width: selectTextWidth } = FJUtil.calcTextSize(selectedText, {
            fontSize: 15,
        });
        if (selectTextWidth > rect.width) {
            left = rect.left + rect.width / 2 - SELECT_COMPONENT_WIDTH;
        } else {
            left = (clientX + mouseDownRef.current.clientX) / 2 - SELECT_COMPONENT_WIDTH;
        }
        top = Math.max(minY, rect.top);
        return { left, top };
    };
    const _onMouseUp = async event => {
        // 拖动框选字符，松开鼠标左键后，再点击框选的字符，会第二次显示复制&添加按钮
        await FJUtil.wait(0);
        const selectedText = window.getSelection().toString();
        if (selectedText) {
            selectTextRef.current = selectedText;
            const { clientX, clientY } = event;
            const { left, top } = _calcSelectComponentPosition(selectedText, { clientX, clientY });
            setSelectComponentStyle({
                left,
                top,
                display: 'flex',
            });
        } else {
            setSelectComponentStyle({ display: 'none' });
            selectTextRef.current = '';
        }
        FJUtil.addEvent(window, 'mousedown', onCloseSelectComponent);
        FJUtil.removeEvent(window, 'mouseup', _onMouseUp);
    };
    const onCloseSelectComponent = () => {
        setSelectComponentStyle({ display: 'none' });
        selectTextRef.current = '';
        window.getSelection().removeAllRanges();
        FJUtil.removeEvent(window, 'mousedown', onCloseSelectComponent);
    };
    const _onMouseDown = event => {
        setSelectComponentStyle({ display: 'none' });

        event.stopPropagation();
        mouseDownRef.current = {
            clientX: event.clientX,
            clientY: event.clientY,
        };
        FJUtil.addEvent(window, 'mouseup', _onMouseUp);
    };
    const _onCopy = () => {
        FJUtil.copyText(selectTextRef.current);
        FJMessageStore.addMessage(FJLocalStore._('duplicated-successfully'));
    };
    const _onAddScene = e => {
        e.stopPropagation();
        e.preventDefault();
        addSceneText({ textValue: selectTextRef.current });
    };

    const _drawSelectComponent = () => {
        return (
            <div
                className={styles.select_component}
                style={selectComponentStyle}
                onMouseDown={e => {
                    e.stopPropagation();
                }}
            >
                <FJToolTip title={FJLocalStore._('duplicate')}>
                    {/* zj:包个div */}
                    <div className={styles.icon_box} onClick={_onCopy}>
                        <FJCopyIcon />
                    </div>
                </FJToolTip>
                <FJToolTip title={FJLocalStore._('add')}>
                    <div className={styles.icon_box} onClick={_onAddScene}>
                        <FJAddTextIcon />
                    </div>
                </FJToolTip>
            </div>
        );
    };
    const _drawImageList = () => {
        return (
            <div className={styles.image_container}>
                <div className={styles.image_header}>
                    <div className={styles.title}>{FJLocalStore._('source-media')}</div>
                    <div className={styles.image_header_right}>
                        <FJCheckBox selected={useSpiderImage} dataChange={setUseSpiderImage} />
                        <div className={styles.right_text}>{FJLocalStore._('generate-with-the-source-file')}</div>
                    </div>
                </div>
                <FJSwipe itemWidth={98} space={12} className={styles.image_swiper} needUpdate={true}>
                    {[...spiderData.images].map(item => (
                        <img className={styles.image_item} key={item.url} src={item.url} />
                    ))}
                </FJSwipe>
            </div>
        );
    };
    const isDrawImageList = spiderData?.images && spiderData?.images.length > 0;
    return (
        <div className={styles.container}>
            <div className={styles.main_container}>
                <div className={styles.spider_data} ref={spiderDataRef}>
                    <div className={styles.title}>{FJLocalStore._('source-article')}</div>
                    <div
                        className={classNames(styles.spider_data_content, {
                            [styles.no_image]: !isDrawImageList,
                        })}
                        onMouseDown={_onMouseDown}
                        ref={textareaRef}
                    >
                        {spiderData?.articleBody}
                    </div>
                    {isDrawImageList && _drawImageList()}
                    {_drawSelectComponent()}
                </div>
                <div className={styles.scene_container}>
                    <FJSceneTextListContainer />
                </div>
            </div>
            <FJTextToVideoFooter>
                <FJButton
                    text={FJLocalStore._('next')}
                    className={styles.btn}
                    type={FJButtonType.GRADIENT}
                    onClick={onSpiderEditNext}
                />
            </FJTextToVideoFooter>
        </div>
    );
};

FJUrlToVideoScriptEdit.propTypes = {
    spiderData: PropTypes.object,
    useSpiderImage: PropTypes.bool,
    setUseSpiderImage: PropTypes.func,
    addSceneText: PropTypes.func,
    onSpiderEditNext: PropTypes.func,
};

export default FJUrlToVideoScriptEdit;
